module.exports = __webpack_public_path__ + "media/axiox.1ae591a1.webm";